import { ThunkAction } from '@reduxjs/toolkit';
import { ErroriCarrello } from 'features/sport/components/sportTicket/sportTicketSlice';
import { RootState } from 'lib/centralStore';
import { updatePuntataSistema } from 'features/carrello/carrelloEditQuotaInputSistema/actions';
import { selectSistemiByType } from 'features/carrello/carrelloSelectors';
import { CarrelloActions, TicketErrore } from 'features/carrello/types';
import { getSliceByTipoTicket } from 'features/carrello/utils';

export const updatePuntataSingolaMultipla =
  (puntataInputValue: string): ThunkAction<void, RootState, unknown, CarrelloActions> =>
  async (dispatch, getState) => {
    const tipo = getState().carrello.tipo;
    const { actions } = getSliceByTipoTicket(tipo);
    dispatch(actions.puntataSingolaMultiplaUpdated(puntataInputValue));
    dispatch(
      actions.ticketUpdated({
        puntata: puntataInputValue,
      })
    );
    dispatch(
      actions.erroriRemoved({
        tipoErrore: 'erroriCarrello',
        errore: {
          type: TicketErrore.IncrementoImportoSingolaMultiplaNonCorretto,
        },
      })
    );
    dispatch(actions.isScommettibileToggled(true));
  };

export const updatePuntataAllScommesse =
  (puntataInputValue: string): ThunkAction<void, RootState, unknown, CarrelloActions> =>
  async (dispatch, getState) => {
    const state = getState() as RootState;
    const tipo = state.carrello.tipo;
    const { actions } = getSliceByTipoTicket(tipo);
    const sistemi = selectSistemiByType(state, tipo);

    dispatch(actions.puntataAllScommesseUpdated(puntataInputValue));
    dispatch(actions.sistemiDaGiocareUpdated(sistemi.map((sistema) => sistema.id)));
    sistemi.forEach((sistema) => {
      dispatch(updatePuntataSistema(puntataInputValue ?? 0, true, sistema.id, true));
    });
  };

export const resetPuntataAllScommesse =
  (): ThunkAction<void, RootState, unknown, CarrelloActions> => async (dispatch, getState) => {
    const state = getState() as RootState;
    const tipo = state.carrello.tipo;
    const { actions } = getSliceByTipoTicket(tipo);

    dispatch(actions.puntataAllScommesseUpdated(''));
  };

export const showErroriOnImportoUpdated =
  (type: ErroriCarrello, errore: TicketErrore): ThunkAction<void, RootState, unknown, CarrelloActions> =>
  async (dispatch, getState) => {
    const tipo = getState().carrello.tipo;
    const slice = getSliceByTipoTicket(tipo);
    dispatch(slice.actions.erroriAdded({ errore, tipoErrore: type }));
    dispatch(slice.actions.isScommettibileToggled(false));
  };
